export default "__VITE_ASSET__CKwHsct0__"